module.exports = __webpack_public_path__ + "img/ticket_status06.118c9b7d.png";